'use client'

import Image from 'next/image'
import { s3ImageLoader } from '@/lib/s3-image-loader'

interface S3ImageProps {
  src: string
  alt?: string
  width: number
  height: number
  className?: string
  priority?: boolean
  sizes?: string
}

export function S3Image({
  src,
  alt,
  width,
  height,
  className = '',
  priority = false,
  // ✅ DEFAULT CORRECTO PARA GRILLAS
  sizes = '(max-width: 768px) 50vw, 25vw',
}: S3ImageProps) {
  // ✅ Fallback global de alt (NO rompe nada)
  const safeAlt =
    alt && alt.trim().length > 0 ? alt : 'Imagen de producto Montessori'

  return (
    <Image
      loader={s3ImageLoader}
      src={src}
      alt={safeAlt}
      width={width}
      height={height}
      className={className}
      priority={priority}
      sizes={sizes}
      placeholder='blur'
      blurDataURL='/placeholder-blur.png'
      fetchPriority={priority ? 'high' : undefined}
    />
  )
}
